export const colors = {
  primary: '#F15025',
  secondary: '#2364AA',
  teriary: '#BB4430',
  light: '#F6F0Eb',
  lightGray: 'F9FAFB',
  neutral: '#818479',
  dark: '#252323',
};

export const palette = {
  white: '#ffffff',
  light: '#f6f0eb',

  primary: {
    50: '#fef4ee',
    100: '#fde5d7',
    200: '#fbc7ad',
    300: '#f8a179',
    400: '#f46f43',
    500: '#f15025',
    600: '#e23214',
    700: '#bb2313',
    800: '#951d17',
    900: '#781b16',
    950: '#410a09',
  },

  secondary: {
    50: '#f2f7fd',
    100: '#e5edf9',
    200: '#c5dbf2',
    300: '#92bce7',
    400: '#579ad9',
    500: '#327dc5',
    600: '#2364aa',
    700: '#1d4f87',
    800: '#1c4470',
    900: '#1c3a5e',
    950: '#13253e',
  },

  neutral: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e6e6e6',
    300: '#d6d6d6',
    400: '#a5a5a5',
    500: '#767676',
    600: '#575757',
    700: '#434343',
    800: '#292929',
    900: '#1a1a1a',
    950: '#000000',
  },

  success: {
    50: '#ecfdf4',
    100: '#d2f9e3',
    200: '#a9f1cc',
    300: '#71e4af',
    400: '#35ce8d',
    500: '#14b576',
    600: '#09925f',
    700: '#07754f',
    800: '#085d40',
    900: '#084c36',
    950: '#032b1f',
  },

  warning: {
    50: '#fefde8',
    100: '#fdfcc4',
    200: '#fdf68b',
    300: '#fbea49',
    400: '#f7d818',
    500: '#ecc30b',
    600: '#c89506',
    700: '#9f6b09',
    800: '#84540f',
    900: '#704513',
    950: '#412407',
  },

  error: {
    50: '#fff0f0',
    100: '#ffdddd',
    200: '#ffc0c0',
    300: '#ff9494',
    400: '#ff5757',
    500: '#ff2323',
    600: '#ff0000',
    700: '#d70000',
    800: '#b10303',
    900: '#920a0a',
    950: '#500000',
  },
} as const;

export const DefaultTransition = {
  type: 'spring',
  mass: 1,
  damping: 40,
  stiffness: 750,
};

const font = {
  medium: 'Satoshi-Bold',
  book: 'Satoshi-Regular',
};

export const spacing = {
  px: 1,
  0: 0,
  0.5: 2,
  1: 4,
  1.5: 6,
  2: 8,
  2.5: 10,
  3: 12,
  3.5: 14,
  4: 16,
  5: 20,
  6: 24,
  7: 28,
  8: 32,
  9: 36,
  10: 40,
  11: 44,
  12: 48,
  14: 56,
  16: 64,
  20: 80,
  24: 96,
  28: 112,
  32: 128,
  36: 144,
  40: 160,
  44: 176,
  48: 192,
  52: 208,
  56: 224,
  60: 240,
  64: 256,
  72: 288,
  80: 320,
  96: 384,
} as const;

export const typography = {
  d2: {
    fontFamily: font.medium,
    fontSize: 96,
    lineHeight: '119px',
    letterSpacing: '0.04em',
  },
  h3: {
    fontFamily: font.medium,
    fontSize: 32,
    lineHeight: '38px',
  },
  h4: {
    fontFamily: font.medium,
    fontSize: 28,
    lineHeight: '34px',
  },
  s2: {
    fontFamily: font.book,
    fontSize: 16,
    lineHeight: '24px',
  },
} as const;
